import { Thread } from "../../types/copilot/Chat"
//import ajax from "../plugins/AjaxService"



const index = (agent: string): Promise<{ threads: Thread[] }> => {
	return [] as any
	//return ajax.get(`agents/${agent}/threads`)
}

const get = (agent: string, threadId: string): Promise<{ state: any }> => {
	return { state: null } as any
	//return ajax.get(`agents/${agent}/threads/${threadId}/state`)
}

const threadsApi = {
	index,
	get,
}

export default threadsApi